// DOC-DEPS: LLM.md -> docs/ACTIVITY_LEXICON.md
//
// English activity lexicon.
// Extracted from liveInputRules.en.ts.

import type { ActivityLexicon } from './types.js';

export const enActivityLexicon: ActivityLexicon = {
  strongPhrases: [
    'work', 'working', 'worked',
    'task', 'tasks',
    'doc', 'docs', 'deck', 'decks', 'inbox', 'update', 'updates',
    'study', 'studying', 'studied',
    'learning',
    'meet', 'meeting', 'meetings',
    'standup', 'daily standup', 'sync', '1:1', '1:1s', 'one-on-one', 'one-on-ones',
    'run', 'running', 'ran',
    'walk', 'walking', 'walked',
    'exercise', 'exercising',
    'gym', 'workout',
    'class', 'classes', 'lecture', 'lab', 'homework', 'paper', 'assignment', 'flashcards', 'anki',
    'yoga', 'pilates',
    'meditation', 'meditating',
    'breakfast', 'lunch', 'dinner', 'brunch', 'meal',
    'drink water', 'drinking water', 'hydrate', 'hydrating',
    'drink tea', 'make tea', 'brew tea', 'make coffee', 'brew coffee',
    'fill water bottle', 'refill water bottle',
    'boil water', 'boiled water', 'boiling water',
    'cook rice', 'cooked rice', 'steam rice', 'wash rice',
    'cook breakfast', 'cook lunch', 'cook dinner', 'cook at home',
    'prepare meal', 'meal prep', 'food prep', 'prep ingredients',
    'make soup', 'made soup', 'make porridge', 'cook noodles', 'chop vegetables', 'wash vegetables',
    'grocery shopping', 'go grocery shopping', 'go to market',
    'buy groceries', 'bought groceries', 'buy vegetables', 'buy fruits', 'buy milk', 'buy bread', 'buy eggs',
    'restock groceries', 'restock supplies',
    'shopping', 'grocery', 'groceries',
    'clean', 'cleaning', 'laundry', 'chores',
    'do dishes', 'wash dishes', 'dishes', 'shower', 'bed', 'order', 'take out trash',
    'vacuum', 'mop floor', 'wipe table', 'tidy room',
    'make bed', 'change bedsheets', 'fold clothes', 'hang laundry', 'do laundry', 'air dry clothes',
    'commute', 'commuting', 'drive', 'driving', 'taxi', 'subway', 'bus', 'train',
    'reading', 'read',
    'writing', 'write',
    'report', 'reports',
    'presentation', 'presentations',
    'slides',
    'email', 'emails', 'mail',
    'ticket', 'tickets',
    'call', 'calling', 'called', 'video call',
    'code', 'coding', 'coded',
    'debug', 'debugging',
    'fix', 'fixing',
    'deploy', 'deploying', 'deployed',
    'push', 'pushing', 'pushed',
    'commit', 'committing', 'committed',
    'ship', 'shipped', 'shipping',
    'release', 'released', 'releasing',
    'cook', 'cooking', 'cooked',
    'swim', 'swimming',
    'hike', 'hiking',
    'cycle', 'cycling', 'bike', 'biking',
    'play', 'playing', 'games', 'gaming',
    'movie', 'movies', 'film',
    'anime', 'manga', 'reading comic',
    'music', 'song', 'playlist',
    'podcast', 'listening to',
    'doctor appointment', 'dentist appointment',
    'pay bills', 'paying bills', 'paid bills',
    'exhibition', 'museum',
    'date', 'family', 'friend', 'friends', 'sprint', 'quiz', 'test', 'midterm', 'final', 'deadlift',
    'stream', 'livestream', 'youtube', 'shorts',
    'nap', 'napping', 'resting',
    'skincare', 'morning routine', 'night routine',
    'binge watching', 'binge-watching',
    'hit the gym', 'hit the pool',
    'hopped on a call', 'jumped on a call',
    'ran errands', 'errands',
    'haircut', 'massage', 'checkup', 'physical',
    'takeout', 'delivery', 'ordered food',
    'batch cooking', 'meal prepped',
    // strength / gym movements
    'lift', 'lifting', 'lifted',
    'squat', 'squatting', 'squats',
    'bench press', 'bench pressing', 'benching',
    'deadlift', 'deadlifting',
    'row', 'rowing',
    'pull-ups', 'push-ups', 'pushups', 'pullups', 'chin-ups',
    'leg day', 'upper body', 'core workout',
    // outdoor / adventure sports
    'climb', 'climbing', 'climbed',
    'boulder', 'bouldering',
    'surf', 'surfing', 'surfed',
    'ski', 'skiing', 'skied',
    'snowboard', 'snowboarding',
    'skate', 'skating', 'skateboard', 'skateboarding',
    'golf', 'golfing',
    'bowl', 'bowling',
    // martial arts / combat
    'boxing', 'box',
    'kickboxing',
    'martial arts', 'judo', 'bjj', 'muay thai', 'wrestling',
    'sparring',
    // creative & hobbies
    'journal', 'journaling', 'journaled',
    'sketch', 'sketching', 'sketched',
    'draw', 'drawing', 'drew',
    'paint', 'painting', 'painted',
    'craft', 'crafting',
    'knit', 'knitting',
    'sew', 'sewing',
    'bake', 'baking', 'baked',
    'garden', 'gardening',
    'photography', 'photographing',
    // professional / work extras
    'brainstorm', 'brainstorming', 'brainstormed',
    'design', 'designing', 'designed',
    'edit', 'editing', 'edited',
    'proofread', 'proofreading',
    'interview', 'interviewing', 'interviewed',
    'prototype', 'prototyping',
    'network', 'networking',
    'freelance', 'freelancing',
    'intern', 'interning',
    'research', 'researching', 'researched',
    // wellness / mindfulness
    'breathwork', 'breathing exercises',
    'therapy', 'therapist', 'counseling', 'counselling',
    'journaling',
    'fasting', 'intermittent fasting',
    // travel / errands
    'travel', 'traveling', 'travelling', 'traveled', 'travelled',
    'trip', 'flight', 'road trip',
    'pack', 'packing', 'packed',
    'unpack', 'unpacking',
    'move', 'moving house',
    'dry cleaning', 'pharmacy', 'bank',
    // volunteer / social good
    'volunteer', 'volunteering', 'volunteered',
    'donate', 'donating', 'donated',
    'tutor', 'tutoring',
    // basic verbs not covered above
    'eat', 'eating', 'ate', 'eaten',
    'sleep', 'sleeping',
    'dance', 'dancing', 'danced',
    'sing', 'singing', 'sang',
    // missing past tenses & conjugations
    'meditated', 'slept', 'napped', 'hiked', 'biked',
    // fitness extras
    'cardio', 'hiit', 'tabata', 'crossfit',
    'zone 2', 'zone 1', 'zone 3',
    'active recovery', 'rest day', 'recovery day',
    'foam rolling', 'ice bath', 'cold plunge',
    'physio', 'physical therapy', 'chiropractor', 'acupuncture',
    // study extras
    'leetcode', 'hackerrank', 'codewars', 'lintcode',
    'pset', 'problem set', 'problem sets',
    'study group', 'study session', 'study hall', 'study buddy',
    'cram session', 'cram',
    'duolingo', 'language practice',
    'thesis', 'dissertation', 'capstone',
    'viva', 'defense', 'thesis defense',
    // entertainment - social media & streaming
    'tiktok', 'reels', 'snapchat',
    'doomscroll', 'doomscrolling', 'doom scrolling',
    'netflix', 'hulu', 'disney+', 'streaming',
    // life extras
    'adulting', 'wfh',
    'errands', 'admin',
    'taxes', 'tax return', 'paperwork',
    'sick day', 'mental health day',
    // family / caregiving / pets
    'walk the dog', 'walked the dog', 'feed the dog', 'fed the dog', 'feed the cat', 'fed the cat',
    'pet care', 'vet', 'vet appointment',
    'pick up kids', 'drop off kids', 'school run', 'daycare dropoff', 'daycare pickup',
    'caregiving', 'babysitting',
    // home / maintenance
    'trash', 'take out recycling', 'recycling', 'declutter', 'organize closet',
    'home repair', 'fix sink', 'fix faucet', 'assemble furniture',
    'car wash', 'car maintenance', 'oil change', 'fuel up', 'gas up',
    // admin / appointments / life events
    'book appointment', 'booked appointment', 'registered', 'signed up', 'rsvp', 'attended', 'joined',
    'rescheduled', 'postponed', 'renew license', 'renew passport', 'dmv',
    'pay rent', 'paid rent', 'file taxes', 'filed taxes',
    'birthday party', 'wedding', 'baby shower', 'funeral',
    // Query / edit / submit / auth operational phrases
    'query logs', 'query data', 'search records', 'look up order', 'track package', 'filter results', 'refine query',
    'edit document', 'modify config', 'update profile', 'revise copy', 'modify', 'editing', 'revising',
    'make payment', 'made payment', 'payment', 'pay invoice', 'paid invoice', 'process payment', 'wire transfer', 'bank transfer', 'settle bill',
    'check order', 'verify order', 'check invoice', 'verify invoice', 'reconcile account', 'reconcile accounts', 'reconciliation', 'cross-check data',
    'submit ticket', 'submit request', 'submit pr', 'submit for review',
    'verify identity', 'identity verification', 'two-factor authentication', 'sign in', 'sign out', 'reset password',
    'bind phone number', 'unlink device', 'upload file', 'export report',
  ],
  verbs: [],
  phrasePatterns: [
    /\b(i am|i'm|im)\s+(working|studying|coding|running|walking|cooking)\b/i,
    /\b(working|studying|coding|running|walking|cooking)\s+(now|right now)\b/i,
    /\b(study|studying|review|reviewing|learn|learning)\s+(?!about\s+to\b|how\s+to\b)([a-z][a-z0-9-]*(\s+[a-z][a-z0-9-]*){0,3})\b/i,
    /\b(just\s+)?(had|did|wrapped\s+up)\s+(a\s+)?(meeting|workout|class|call)\b/i,
    /\b(just\s+)?got\s+home\b/i,
    /\b(went|headed\s+out)\s+for\s+(a\s+)?(run|walk)\b/i,
    /\b(out\s+for\s+(a\s+)?coffee)\b/i,
    /\b(grabbing|grabbed|having|had)\s+(a\s+)?coffee\b/i,
    /\b(writing|working\s+on|reviewing)\s+(the\s+)?(report|doc|assignment|ticket|code)\b/i,
    /\b(sending|replying\s+to|answering)\s+(emails?|messages?)\b/i,
    /\b(preparing|building|drafting|updating)\s+(a\s+|the\s+)?(presentation|slides|roadmap|report|doc|deck)\b/i,
    /\b(deep\s+in|buried\s+in)\s+(a\s+|the\s+|my\s+)?(doc|deck|report|paperwork|spreadsheet|inbox)\b/i,
    /\b(finishing\s+up|wrapping\s+up|polishing)\s+(a\s+|the\s+|my\s+)?(deck|doc|report|paper|slides?)\b/i,
    /\b(doing|having|in)\s+(a\s+)?(1:1|1:1s|one-on-one|one-on-ones|one\s+on\s+one|one\s+on\s+ones|sync|sync-up)\b/i,
    /\b(in\s+(a\s+)?)sync\b/i,
    /\b(grinding\s+through|working\s+through)\s+(my\s+)?(inbox|emails?)\b/i,
    /\b(just\s+)?sent\s+(the\s+|my\s+)?((weekly|status)\s+)?(update|report|deck|slides?|doc|paper)\b/i,
    /\b(debugging|fixing|testing)\b/i,
    /\b(just\s+)?(pushed|shipped|deployed|released)\s+(a\s+|the\s+)?(fix|feature|update)\b/i,
    /\b(driving|taking)\s+(a\s+)?(taxi|bus|train|subway)\b/i,
    /\b(commuting|on\s+the\s+way\s+to)\s+(work|office|school|gym)\b/i,
    /\b(doing|finished|did)\s+(the\s+)?(laundry|cleaning|dishes|meal\s+prep|grocery\s+shopping)\b/i,
    /\b(doing|working\s+on)\s+(my\s+)?homework\b/i,
    /\b(cramming)\s+for\s+(my\s+|the\s+)?(exam|quiz|test|midterm|final)\b/i,
    /\b(in|at)\s+(class|lecture|lab)\b/i,
    /\b(doing|reviewing)\s+(anki\s+)?flashcards\b/i,
    /\b(office\s+hours?)\b/i,
    /\b(taking|took)\s+(a\s+)?shower\b/i,
    /\b(just\s+)?woke\s+up\b/i,
    /\b(getting|got)\s+ready\s+for\s+bed\b/i,
    /\b(picking\s+up|picked\s+up)\s+(my\s+)?order\b/i,
    /\b(playing|played)\s+(football|soccer|basketball|badminton|tennis|ping\s+pong)\b/i,
    /\b(swimming|hiking|cycling|biking|doing\s+yoga|doing\s+pilates|stretching)\b/i,
    /\b(did|ran)\s+(a\s+)?\d+(k|km|mile|miles)\b/i,
    /\b(leg\s+day)\b/i,
    /\b(pr['’]?d)\s+(on\s+)?(deadlift|squat|bench)\b/i,
    /\b(watching|watched)\s+(a\s+)?(movie|series|tv\s+show|livestream)\b/i,
    /\b(listening\s+to)\s+(a\s+)?(podcast|music)\b/i,
    /\b(hanging\s+out|meeting|met|visiting|visited)\s+(friends|family)\b/i,
    /\b(catching\s+up)\s+with\s+(family|friends?)\b/i,
    /\b(calling|called)\s+(my\s+)?(mom|mother|dad|father|parents?|family|friend|friends)\b/i,
    /\b(on\s+(a\s+)?)date\b/i,
    /\b(met)\s+(an?\s+old\s+)?friend\b/i,
    /\b(went\s+to)\s+(a\s+)?(concert|museum|exhibition|cafe)\b/i,
    /\b(karaoke|board\s+games?|game\s+night|date\s+night)\b/i,
    /\b(chatting|chatted)\s+with\b/i,
    /\b(hanging\s+out|hung\s+out)\b/i,
    /\b(grabbing|grabbed|having|had)\s+(breakfast|lunch|dinner|brunch)\b/i,
    /\b(waiting\s+in\s+line)\b/i,
    /\b(back[-\s]?to[-\s]?back)\s+meetings\b/i,
    /\b(reading|read|finished\s+reading)\s+(a\s+)?(book|novel|chapter)\b/i,
    /\b(watching|watched|reading|read)\s+(anime|manga|novel|novels)\b/i,
    /\b(reading|read|skimming|skimmed)\s+(the\s+)?(newspaper|news|article|articles)\b/i,
    /\b(journaling|journaled|writing|wrote)\s+(a\s+)?(journal|diary|journal\s+entry)\b/i,
    /\b(taking|took|reviewing)\s+(notes|meeting\s+notes|class\s+notes)\b/i,
    /\b(doctor|dentist)\s+(appointment|visit)\b/i,
    /\b(paying|paid)\s+(the\s+)?(bills?|rent|utilities)\b/i,
    /\b(gaming|playing\s+games|played\s+games)\b/i,
    /\b(on\s+my\s+way\s+to|at)\s+(the\s+)?(office|gym|school)\b/i,
    /\b(in|on)\s+(a\s+)?meeting\b/i,
    /\bvideo\s+call\b/i,
    /\b(pulled\s+an\s+all[-\s]?nighter)\b/i,
    /\b(got\s+promoted)\b/i,
    /\b(wrapped\s+(the\s+)?)sprint\b/i,
    /\b(bombed|aced)\s+(that\s+|the\s+|my\s+)?(quiz|test|exam|midterm|final|presentation)\b/i,
    /\b(meal\s+prepped|batch\s+cooked)\b/i,
    /\b(hit\s+(the\s+)?(gym|pool|track))\b/i,
    /\b(took\s+(a\s+)?(nap|break|walk))\b/i,
    /\b(had\s+(a\s+)?(nap|rest))\b/i,
    /\b(hopped\s+on\s+(a\s+)?(call|zoom|meet))\b/i,
    /\b(jumped\s+on\s+(a\s+)?(call|zoom|meet))\b/i,
    /\b(got\s+(a\s+)?(haircut|massage|checkup|physical))\b/i,
    /\b(ran\s+(some\s+)?(errands?))\b/i,
    /\b(knocked\s+out\s+(the\s+|my\s+)?(workout|run|chores))\b/i,
    /\b(binge(d|[- ]watching)?)\s+(a\s+|the\s+)?(show|series|season|anime)\b/i,
    /\b(ordered\s+(food|takeout|delivery|pizza|sushi))\b/i,
    /\b(went\s+for\s+(a\s+)?(swim|hike|drive|ride))\b/i,
    /\b(did\s+(my\s+)?(skincare|morning\s+routine|night\s+routine))\b/i,
    // strength training
    /\b(did\s+(some\s+)?(lifting|squats|pull-ups|push-ups|deadlifts|rows))\b/i,
    /\b(hit\s+(a\s+)?new\s+pr|set\s+a\s+new\s+pr)\b/i,
    // creative hobbies
    /\b(did\s+some\s+)?(journaling|sketching|drawing|painting|crafting|knitting|sewing|baking|gardening)\b/i,
    /\b(played\s+(the\s+)?(guitar|piano|violin|bass|drums|keyboard|ukulele))\b/i,
    // travel
    /\b(just\s+)?(landed|arrived|got\s+back|touched\s+down)\b/i,
    /\b(packed\s+(my\s+)?(bag|bags|suitcase))\b/i,
    /\b(on\s+(a\s+)?trip|going\s+on\s+a\s+trip|took\s+a\s+trip)\b/i,
    /\b(at\s+the\s+airport|on\s+(the\s+)?flight|on\s+the\s+plane)\b/i,
    // wellness
    /\b(had\s+(a\s+)?therapy\s+session|went\s+to\s+therapy)\b/i,
    /\b(did\s+(some\s+)?breathwork|breathing\s+exercises)\b/i,
    // extra social / life
    /\b(volunteered|did\s+volunteer\s+work)\b/i,
    /\b(went\s+to\s+(the\s+)?(pharmacy|bank|post\s+office|dry\s+cleaner))\b/i,
    /\b(picked\s+up\s+(my\s+)?(prescription|meds|medicine))\b/i,
    // medical / health visits
    /\b(went\s+to|saw|visited)\s+(the\s+)?(doctor|dentist|therapist|physician|clinic|hospital|urgent\s+care|chiropractor|dermatologist|ophthalmologist|optometrist)\b/i,
    /\b(at\s+the\s+)(doctor|dentist|hospital|clinic|urgent\s+care|chiropractor)\b/i,
    /\b(got\s+(a\s+)?(checkup|physical|blood\s+test|vaccination|shot|booster))\b/i,
    /\b(took|taking)\s+(my\s+|some\s+|a\s+|the\s+)?(meds|medicine|medication|pills?|vitamins?|supplements?|antibiotics?|painkillers?)\b/i,
    /\b(got|came\s+down\s+with|caught|picked\s+up)\s+(a\s+)?(cold|flu|fever|bug|migraine|headache|stomach\s+bug)\b/i,
    /\b(called\s+in\s+sick|took\s+(a\s+)?sick\s+day|on\s+sick\s+leave)\b/i,
    /\b(recovering|recovering\s+from)\s+(a\s+)?(cold|flu|injury|surgery)\b/i,
    /\b(physical\s+therapy|physio\s+(session|appointment)?|acupuncture\s+(session|appointment)?)\b/i,
    // fitness extras
    /\b(zone\s+[123](\s+cardio)?|hiit(\s+(class|session|workout))?|tabata|crossfit)\b/i,
    /\b(rest\s+day|active\s+recovery|recovery\s+day|recovery\s+run)\b/i,
    /\b(foam\s+rolling|foam\s+roll(ed)?)\b/i,
    /\b(ice\s+bath|cold\s+plunge|cold\s+shower)\b/i,
    /\b(did\s+(some\s+)?(cardio|abs|core|stretching|mobility\s+work))\b/i,
    /\b(ran\s+\d+\s*(k|km|miles?|laps?)|walked\s+\d+\s*(k|km|miles?|steps?))\b/i,
    /\b(hit\s+(a\s+)?new\s+(pr|pb|personal\s+record|personal\s+best))\b/i,
    // study extras
    /\b(grinding\s+(through\s+)?(leetcode|hackerrank|codewars|problems?|practice\s+problems?|psets?|homework))\b/i,
    /\b(leetcode\s+(grind|session|problem|easy|medium|hard))\b/i,
    /\b(study\s+(group|session|hall|buddy))\b/i,
    /\b(cram\s+session|cramming\s+all\s+night)\b/i,
    /\b(problem\s+set|pset)\b/i,
    /\b(mock\s+(exam|test|interview)|practice\s+(exam|test))\b/i,
    /\b(group\s+(project|work|assignment|presentation))\b/i,
    /\b(online\s+(class|course|lecture|session|workshop))\b/i,
    /\b(working\s+on\s+(my\s+)?(thesis|dissertation|capstone|research\s+project))\b/i,
    /\b(wrote\s+(an?\s+)?(essay|paper|thesis|dissertation|report|RFC|spec|proposal))\b/i,
    /\b(submitted\s+(my\s+|the\s+)?(paper|assignment|homework|thesis|report))\b/i,
    /\b(aced|passed|failed|bombed|flunked)\s+(the\s+|my\s+|that\s+)?(viva|defense|oral|qualifying\s+exam|bar\s+exam|licensing\s+exam)\b/i,
    /\b(did\s+(some\s+)?(duolingo|language\s+practice|vocab\s+review|anki))\b/i,
    /\b(reading\s+(for|through)\s+(class|the\s+exam|my\s+course))\b/i,
    /\b(took\s+(an?\s+)?(online\s+)?(course|class|lesson))\b/i,
    /\b(watched\s+(a\s+|the\s+|an?\s+)?(lecture|tutorial|lesson|ted\s+talk|course\s+video))\b/i,
    // social media / entertainment
    /\b(scrolling\s+(through\s+)?(tiktok|instagram|twitter|reddit|x|reels|social\s+media|my\s+feed|the\s+feed|linkedin))\b/i,
    /\b((on|checking|browsing|opening)\s+(tiktok|instagram|reels|twitter|x|reddit|snapchat|linkedin))\b/i,
    /\b(doom[\s-]?scroll(ing)?)\b/i,
    /\b(caught\s+up\s+on\s+(the\s+)?(news|twitter|reddit|socials|instagram|tiktok))\b/i,
    /\b(fell\s+down\s+(a\s+)?rabbit\s+hole)\b/i,
    /\b(watching\s+(netflix|hulu|disney\+|prime|hbo|a\s+show|something\s+on))\b/i,
    /\b(finished\s+(a\s+|the\s+)?(game|level|chapter|book|series|season|show|episode|campaign))\b/i,
    /\b(beat\s+(a\s+|the\s+)?(game|boss|level|dungeon|raid))\b/i,
    /\b(went\s+to\s+(the\s+)?(movies|cinema|theater|theatre))\b/i,
    /\b(at\s+the\s+(movies|cinema|theater|theatre))\b/i,
    /\b(re-?watching|re-?reading|re-?playing)\b/i,
    /\b(started\s+(a\s+|the\s+|new\s+)?(show|series|game|book|anime|manga))\b/i,
    /\b(picked\s+up\s+(a\s+)?(new\s+)?(book|game|hobby))\b/i,
    /\b(went\s+to\s+(a\s+)?(bar|club|lounge|pub|party|show|gig|festival))\b/i,
    /\b(at\s+a\s+(bar|club|party|gig|festival|show))\b/i,
    // life extras
    /\b(stuck\s+in\s+traffic|sitting\s+in\s+traffic|caught\s+in\s+traffic)\b/i,
    /\b(had\s+(a\s+)?(fight|argument|disagreement)\s+with)\b/i,
    /\b(stress[\s-]?(cooking|eating|cleaning|shopping|baking|spending))\b/i,
    /\b(worked\s+from\s+home|working\s+from\s+home|wfh\s+today)\b/i,
    /\b(did\s+(my\s+|the\s+)?(taxes|tax\s+return|tax\s+filing))\b/i,
    /\b(filed\s+(my\s+)?(taxes|tax\s+return))\b/i,
    /\b(took\s+(a\s+)?mental\s+health\s+day)\b/i,
    /\b(vegged?\s+out)\b/i,
    /\b(just\s+)?(kicked\s+back|lounged\s+around|did\s+nothing)\b/i,
    /\b(adulting\s+(today|all\s+day|so\s+hard))\b/i,
    /\b(did\s+(some\s+)?(adulting|admin|errands?))\b/i,
    /\b(dealing\s+with\s+(the\s+)?(landlord|insurance|bank|bureaucracy|paperwork|admin))\b/i,
    /\b(sorted\s+(out|through)\s+(my\s+)?(stuff|closet|inbox|finances|paperwork))\b/i,
    /\b(cleaned\s+(out|up)\s+(my\s+)?(room|closet|desk|car|inbox))\b/i,
    /\b(moved\s+(into|out\s+of|apartments?|houses?|places?))\b/i,
    /\b(had\s+(a\s+)?(long|rough|good|busy|productive|quiet)\s+day)\b/i,
    /\b(sat\s+through\s+(a\s+|the\s+)?(meeting|lecture|class|presentation|call|session))\b/i,
    /\b(in\s+(back[\s-]?to[\s-]?back|back[\s-]?to[\s-]?back)\s+(meetings|calls|sessions))\b/i,
    /\b(said\s+yes\s+to|committed\s+to)\s+(plans?|an?\s+event)\b/i,
    /\b(went\s+to\s+(a\s+)?(networking\s+event|mixer|meetup|conference|workshop))\b/i,
    // caregiving / pet care
    /\b(walk(ing|ed)?\s+(my\s+)?dog|took\s+(my\s+)?dog\s+for\s+a\s+walk)\b/i,
    /\b(feed(ing|\s+)?(my\s+)?(dog|cat)|gave\s+(my\s+)?(dog|cat)\s+food)\b/i,
    /\b(at\s+the\s+vet|vet\s+(appointment|visit)|took\s+(my\s+)?pet\s+to\s+the\s+vet)\b/i,
    /\b(babysitt(ing|er)?|watching\s+the\s+kids|looking\s+after\s+(my\s+)?(kid|kids|child|children))\b/i,
    /\b(pick(ing)?\s+up|drop(ping)?\s+off)\s+(my\s+)?(kid|kids|child|children)\b/i,
    /\b(school\s+run|daycare\s+(drop\s?off|pickup|pick\s?up))\b/i,
    // home / maintenance
    /\b(took\s+out\s+the\s+(trash|recycling)|trash\s+day|recycling\s+day)\b/i,
    /\b(declutter(ing|ed)?|organizing\s+(my\s+)?closet)\b/i,
    /\b(fix(ing|ed)?\s+(the\s+)?(sink|faucet)|home\s+repair|assembled\s+furniture)\b/i,
    /\b(got\s+(a\s+)?(car\s+wash|oil\s+change)|did\s+car\s+maintenance)\b/i,
    /\b(fuel(ed)?\s+up|gas(sed)?\s+up|filled\s+up\s+(the\s+)?tank)\b/i,
    // admin / appointments / logistics
    /\b(book(ed)?\s+(a\s+)?(doctor|dentist|therapy|vet|salon|hair|nail)?\s*appointment)\b/i,
    /\b(register(ed)?\s+for|signed\s+up\s+for|rsvp(?:'d)?\s+to|joined|attended)\s+(an?\s+)?(class|event|workshop|meetup|conference|webinar)\b/i,
    /\b(cancel(l)?ed|rescheduled|postponed)\s+(my\s+|the\s+)?(appointment|meeting|class|session|trip)\b/i,
    /\b(renew(ed|ing)?\s+(my\s+)?(license|passport)|went\s+to\s+the\s+dmv)\b/i,
    /\b(filed?\s+(my\s+)?taxes|paid\s+(my\s+)?rent)\b/i,
    // social / life events
    /\b(went\s+to\s+(a\s+)?(wedding|birthday\s+party|baby\s+shower|funeral))\b/i,
    /\b(host(ed|ing)?\s+(a\s+)?(dinner|party|bbq|potluck))\b/i,
  ],
};

/**
 * Place nouns used for structural go+place activity detection.
 * Only includes places NOT already covered as tokens in strongPhrases.
 * Combined with movement-verb prefixes in latinSignalExtractor.
 */
export const enPlaceNouns: readonly string[] = [
  // exercise & sport (pool/track not in strongPhrases as bare tokens)
  'pool', 'track', 'court', 'studio', 'field',
  // education
  'library', 'campus',
  // daily errands / social (cafe, bar etc. only covered by specific phrasePatterns)
  'cafe', 'coffee shop', 'park', 'bar', 'market',
  // health
  'hospital', 'clinic',
  // retail / transport
  'supermarket', 'mall', 'store', 'station', 'airport',
];
